<template>
  <base-input
    v-model="formData"
    :error="validateLength(formData)"
    placeholder="Ex: Resposta"
  />
</template>

<script>
export default {
  name: "TextAvaliationItemStrategy",
  props: {
    value: {},
    avaliationItem: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  methods: {
    validateLength(value) {
      if (!value) return

      if (this.min && value.length < this.min) {
        return `A resposta deve possuir ao menos ${ this.min } caracteres`;
      }

      if (this.max && value.length > this.max) {
        return `A resposta deve possuir até ${ this.max } caracteres`;
      }

      return;
    },
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    config() {
      return this.avaliationItem.config || {};
    },
    min() {
      return this.config.min_length
    },
    max() {
      return this.config.max_length
    },
  },
}
</script>

